import SmallAreaChart from './SmallAreaChart';

export default SmallAreaChart;
